<template>
  <div class="col-span-6 mb-2">
    <label for="combobox" class="block 2xl:text-sm sm:text-xl font-medium text-gray-700">{{field.label}}</label>
    <div class="relative mt-1">
      <input id="combobox"
        type="text"
        placeholder="Buscar..."
        class="block w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-12 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 2xl:text-sm sm:text-xl"
        role="combobox"
        aria-controls="options"
        aria-expanded="false"
        autocomplete="off"
        v-model="queryValue"
        v-on:click="toggleShowOptions"
        v-on:input="filtered($event.target.value)">
      <button
        type="button"
        class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
        v-on:click="toggleShowOptions"
        >
        <!-- Heroicon name: solid/selector -->
        <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>

      <ul v-if="showOptions"
        class="relative z-50 mt-1 max-h-48 w-full overflow-auto rounded-md bg-white py-1 2xl:text-sm sm:text-xl shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        id="options"
        role="listbox"
        aria-labelledby="listbox-label"
        aria-activedescendant="listbox-option"
        >
        <template v-for="item in itemsFiltered">
          <li v-on:click="selectItem(item)" :key="item[field.options_key]" class="relative cursor-default select-none py-1 pl-3 pr-9 text-gray-900" :id="item.id" role="option" tabindex="-1">
            <span class="block truncate">{{item[field.options_label]}}</span>
            <span v-if="selected===item" class="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
            </span>
          </li>
        </template>
      </ul>
    </div>
    <div v-if="field.link !== undefined" class="flex-shrink-0 mt-2">
        <button v-on:click="clickLink(field.link.url)" type="button" class="inline-flex items-center rounded-full border border-transparent py-2 px-1 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
          <!-- Heroicon name: mini/plus -->
          <svg class="-ml-1 mr-0.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
          </svg>
          <span class="text-xs font-medium text-gray-600"> {{field.link.label}} </span>
        </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'search-option-field',
  props: {
    field: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: false
    },
    formdata: {
      type: Object,
      required: true
    }
  },
  created() {
    this.checkDepends()
  },
  mounted() {
    this.componentRef = this.$el;
    document.addEventListener("click", this.onClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onClickOutside);
  },
  watch: {
    formdata: {
      deep: true,
      handler: async function(newVal) {
        if (this.field.depends !== '' && this.field.depends !== undefined) {
          if ( typeof this.dependentdata[this.field.depends] === 'object'){
            if (JSON.stringify(this.dependentdata[this.field.depends]) !== JSON.stringify(newVal[this.field.depends])) {
              this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
              await this.fetchOptions()
            }
          } else {
            if (this.dependentdata[this.field.depends] !== newVal[this.field.depends]) {
              this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
              await this.fetchOptions()
            }
          }
        }
      }
    },
    field: {
      deep: true,
      handler: function(newVal) {
        console.log('field', newVal)
        this.checkDepends()
      }
    },
  },
  methods: {
    onClickOutside(event) {
      if (!this.componentRef.contains(event.target)) {
        this.showOptions = false
      }
    },
    checkDepends() {
      console.log('checkDepends', this.field)
      if (this.field.options.length > 0) {
        this.optionstype = 'fixed'
        this.options = this.field.options
      } else {
        if (this.field.depends === undefined || this.field.depends === "") {
          this.fetchOptions()
          this.checkDefault()
        }
      }
    },
    checkDefault() {
      if (this.field.options_default !== undefined){
        this.$parent.updateValue(this.field.key, this.field.options_default)
      }
    },
    async fetchOptions(){
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        },
        params: {
          key: this.field.options_key,
          id: this.$route.params.record,
          ...this.$store.state.data,
          ...this.formdata,
          ...this.params,
          ...this.dependentdata,
          query: this.$route.query
        }
      }
      const response = await this.$http.get(this.field.uri, config)
      this.items = response.data
      this.filtered('')
      this.showOptions = false
      this.itemsFiltered.forEach(item => {
        if (item.selected){
          this.selectItem(item)
        }
      })
    },
    filtered(query) {
      this.queryValue = query.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      this.showOptions = true
      this.itemsFiltered = query === ''
      ? this.items
      : this.items.filter((item) => {
          return item.label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(this.queryValue.toLowerCase())
        })
    },
    toggleShowOptions() {
      this.showOptions = !this.showOptions;
    },
    selectItem(item) {
      if (JSON.stringify(item) === JSON.stringify(this.selected)){
        this.selected = {}
        if (this.field.options_default !== undefined){
          this.selected['value'] = this.field.options_default
        }
        this.queryValue = ''
      } else {

        this.selected = item
        this.queryValue = item[this.field.options_label]
      }
      this.showOptions = false

      if (typeof this.selected[this.field.options_value] === 'undefined'){
        this.$parent.deleteValue(this.field.key)
        this.checkDefault()
      } else{
        this.$parent.updateValue(this.field.key, this.selected[this.field.options_value])
      }
    },
    clickLink(url) {
      this.$router.push(url)
      this.$router.go()
    }

  },
  data(){
    return {
      componentRef:null,
      showOptions: false,
      selected: {},
      dependentdata: {},
      queryValue: '',
      itemsFiltered: [],
      items: []
    }

  }
}
</script>
